/**
 * Development-only logger utility
 * 
 * Logs to console only in development mode (NODE_ENV !== 'production').
 * In production builds, all logging is suppressed for cleaner console output.
 * 
 * Usage:
 *   import logger from '../utils/logger';
 *   logger.log('Debug message');
 *   logger.error('Error message');
 */

// Browser-safe development detection (no Node.js process.env)
const isDevelopment = typeof window !== 'undefined' && 
                      (window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1' ||
                       window.location.search.includes('debug=true'));

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  }
};

export default logger;

